import { MsalProvider } from '@azure/msal-react';
import { BrowserRouter } from 'react-router-dom';

import { AuthGate } from './auth/AuthGate';
import { msalInstance } from './auth/msal';
import { missingConfig } from './env';
import { AppRoutes } from './routes/AppRoutes';

/**
 * Composition root: configuration check, then MSAL, then router, then shell.
 *
 * The configuration check comes first on purpose. Without a client id MSAL
 * fails inside Entra with a message the user cannot act on, so the app says
 * plainly which variables are missing instead.
 */

function NotConfigured({ missing }: { readonly missing: readonly string[] }) {
  return (
    <div className="centre">
      <h1>CLM is not configured</h1>
      <p className="mut">
        The following environment variables are missing from this deployment. They are set in Azure
        Static Web Apps application settings, or in <code>.env.local</code> for local development —
        see <code>apps/web/.env.example</code>.
      </p>
      <ul>
        {missing.map((name) => (
          <li key={name}>
            <code>{name}</code>
          </li>
        ))}
      </ul>
    </div>
  );
}

export function App() {
  const missing = missingConfig();
  if (missing.length > 0) {
    return <NotConfigured missing={missing} />;
  }

  return (
    <MsalProvider instance={msalInstance}>
      <AuthGate>
        <BrowserRouter>
          <AppRoutes />
        </BrowserRouter>
      </AuthGate>
    </MsalProvider>
  );
}
